export class CreatePipelineRequest {
  public name: string;
  public diameter: number;
  public trackingFileName: string;
  public trackingFile: string;

  public constructor(
    name: string,
    diameter: number,
    trackingFileName: string,
    trackingFile: string
  ) {
    this.name = name;
    this.diameter = diameter;
    this.trackingFileName = trackingFileName;
    this.trackingFile = trackingFile;
  }
}
